import PushPinIcon from '@mui/icons-material/PushPin'
import { Chip, Stack, Tooltip, Typography } from '@mui/material'
import PropTypes from 'prop-types'

const SOURCE_TOOLTIP = {
    explicit: 'Pinned to this connection on the meter itself.',
    location: "Inherited from this property's connection.",
    org_wide: 'Inherited from the org-wide connection.',
    none: 'No connection owns this meter, so nothing fetches it. Assign it to a connection, or create an org-wide default.'
}

/**
 * The provider connection that owns a meter, for the admin meter lists.
 *
 * Shows the resolution *source* as well as the provider, because on a multi-connection estate
 * "which account is this meter actually on" is not otherwise answerable without opening every
 * meter. The unowned case is called out in error colour — such a meter is silently never
 * fetched, so it has to be visible at a glance rather than only in the data-quality findings.
 */
export default function MeterConnectionCell({ owningConfig }) {
    if (!owningConfig || owningConfig.source === 'none' || !owningConfig.id) {
        return (
            <Tooltip arrow title={SOURCE_TOOLTIP.none}>
                <Chip color="error" label="No connection" size="small" />
            </Tooltip>
        )
    }

    const pinned = owningConfig.source === 'explicit'
    return (
        <Tooltip
            arrow
            title={SOURCE_TOOLTIP[owningConfig.source] ?? owningConfig.source}
        >
            <Stack alignItems="center" direction="row" spacing={0.5}>
                {pinned ? (
                    <PushPinIcon color="action" fontSize="inherit" />
                ) : null}
                <Typography
                    color={pinned ? 'text.primary' : 'text.secondary'}
                    variant="body2"
                >
                    {owningConfig.provider || 'unconfigured'}
                </Typography>
            </Stack>
        </Tooltip>
    )
}

MeterConnectionCell.propTypes = {
    owningConfig: PropTypes.shape({
        id: PropTypes.string,
        provider: PropTypes.string,
        source: PropTypes.string
    })
}
